export default "__VITE_ASSET__85d290dc__"